import { useState } from "react";
import { useAuth } from "react-oidc-context";

export const useResetDemo = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();

  const resetDemo = async (hotelId) => {
    setLoading(true);
    setError(null);

    try {
      const token = auth.user?.access_token;
      if (!token) {
        throw new Error("Token d'authentification manquant");
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL || "/api"}/greenmiles/demos/${hotelId}/reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Erreur lors de la réinitialisation de la démo");
      }

      return data;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const resetState = () => {
    setLoading(false);
    setError(null);
  };

  return {
    resetDemo,
    loading,
    error,
    resetState,
  };
};
